module.exports = __webpack_public_path__ + "img/btn--moyen-v2.93f8867b.svg";